import{a as e}from"./chunk-DMS2IT2J.js";import{a as c}from"./chunk-6JNQ7TTS.js";import{e as t}from"./chunk-QQD3NF3B.js";import{m as o}from"./chunk-HBP5N4FR.js";o();c();function f(r){e.dispatch(t(r))}export{f as a};
//# sourceMappingURL=chunk-MD4V543K.js.map
